//Check value is less than or equal compare value
//PASS: value is valid, returns true
//FAIL: value is invalid, returns false
export const CheckValueLessThanEqual = ({ value, compareValue }) =>
  value <= compareValue;
